/**
 * "Something to review changed" (TMMAPP-0163 item 3): a page whose items to review change while it
 * stays open (a payee-naming run filling the names to review) says so, and the sidebar's count
 * re-reads the served summary. Nothing is counted on the client.
 */
export const REVIEW_CHANGED_EVENT = 'tmm:review-changed';

export function announceReviewChanged(): void {
  window.dispatchEvent(new Event(REVIEW_CHANGED_EVENT));
}
